/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignInCredentials
 */
export interface SignInCredentials {
    /**
     * 
     * @type {string}
     * @memberof SignInCredentials
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInCredentials
     */
    password?: string;
}

/**
 * Check if a given object implements the SignInCredentials interface.
 */
export function instanceOfSignInCredentials(value: object): value is SignInCredentials {
    return true;
}

export function SignInCredentialsFromJSON(json: any): SignInCredentials {
    return SignInCredentialsFromJSONTyped(json, false);
}

export function SignInCredentialsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignInCredentials {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'password': json['password'] == null ? undefined : json['password'],
    };
}

export function SignInCredentialsToJSON(json: any): SignInCredentials {
    return SignInCredentialsToJSONTyped(json, false);
}

export function SignInCredentialsToJSONTyped(value?: SignInCredentials | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'password': value['password'],
    };
}

